/** React imports */
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

/** MUI Imports */
import { ButtonGroup, ClickAwayListener, Grow, MenuItem, MenuList, Paper, Popper } from "@mui/material";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
/** Styles */
// import classes from "./ConvertButton.module.css";

/** MUI Icons */
import { useDispatch, useSelector } from "react-redux";
import { addCompanyID, addCredits, addSelected, addSubscription } from "../../../redux/userSlice";
import BaseButton from "../../ui/BaseButton";

import subscriptionService from "../../../services/subscription";

const ConvertButton = (props) => {
    const { setSelectedCompany, setMobileOpen, setOpenCollapse } = props;

    //Buttom group
    const [openBtnGroupSend, setOpenBtnGroupSend] = useState(false);
    const anchorRefBtnGroup = useRef(null);
    const [selectedIndexBtnGroup, setSelectedIndexBtnGroup] = useState(null);

    const todos = useSelector((state) => state.value);
    const dispatch = useDispatch();

    /** Internationalization i18n */
    const [t] = useTranslation("global");
    const navigate = useNavigate();

    const optionsGroupSend = [
        { data: t("navBar.eecc"), id: 0 },
        { data: t("converter.checks"), id: 1 },
        { data: t("navBar.salesInvoices"), id: 2 },
        { data: t("navBar.purchaseInvoices"), id: 3 },
        // { data: t("navBar.receipts"), id: 3 },
    ];

    useEffect(() => {
        if (todos.selected === "ddlAccounts") {
            setSelectedIndexBtnGroup(0);
        } else if (todos.selected === "ddlSalesInv") {
            setSelectedIndexBtnGroup(1);
        } else if (todos.selected === "ddlPurchaseInv") {
            setSelectedIndexBtnGroup(2);
        }
    }, [todos.selected]);

    const handleClick = async (index) => {
        setMobileOpen(false);
        setOpenCollapse(false);

        const newComp = todos.allComData.filter(
            (company) => !company.franchise_name && company.franchise_id === todos.franchiseID
        )[0];

        if (!todos.companyID) {
            setSelectedCompany(newComp);
            dispatch(addCompanyID(newComp._id));
            dispatch(
                addSubscription({
                    value: newComp.id_status,
                    last_value: newComp.id_last_status,
                    plan: newComp.subscription_plan,
                })
            );

            await subscriptionService
                .getFranchiseCredits({ company_id: newComp._id })
                .then((response) => dispatch(addCredits(response)))
                .catch((err) => console.log(err));
        }

        if (index !== null) {
            if (index === 0) {
                dispatch(addSelected("ddlAccounts"));
                navigate("/convert");
            } else if (index === 1) {
                dispatch(addSelected("ddlChecks"));
                navigate("/convert", { state: { checkTab: true } });
            } else if (index === 2) {
                dispatch(addSelected("ddlSalesInv"));
                navigate(`/convert/invoices`);
            } else if (index === 3) {
                dispatch(addSelected("ddlPurchaseInv"));
                navigate(`/convert/bills`);
            } else {
                navigate("/convert");
            }
        } else {
            if (todos.selected === "ddlAccounts") {
                navigate("/convert");
                setSelectedIndexBtnGroup(0);
            } else if (todos.selected === "ddlChecks") {
                navigate("/convert", { state: { checkTab: true } });
                setSelectedIndexBtnGroup(1);
            } else if (todos.selected === "ddlSalesInv") {
                navigate(`/convert/invoices`);
                setSelectedIndexBtnGroup(2);
            } else if (todos.selected === "ddlPurchaseInv") {
                navigate(`/convert/bills`);
                setSelectedIndexBtnGroup(3);
            } else {
                navigate("/convert");
                setSelectedIndexBtnGroup(0);
            }
        }
    };

    const handleCloseBtnGroup = (event) => {
        if (anchorRefBtnGroup.current && anchorRefBtnGroup.current.contains(event.target)) {
            return;
        }

        setOpenBtnGroupSend(false);
    };

    const handleMenuItemClickBtnGroup = (event, index) => {
        setSelectedIndexBtnGroup(index);
        setOpenBtnGroupSend(false);
        handleClick(index);
    };

    const handleToggleBtnGroup = () => {
        setOpenBtnGroupSend((prevOpenBtnGroupSend) => !prevOpenBtnGroupSend);
    };

    return (
        <>
            <ButtonGroup variant="outlined" ref={anchorRefBtnGroup} aria-label="split button" color="inherit">
                <BaseButton
                    disableElevation
                    color={todos.companyID ? "primary" : "secondary"}
                    sx={{ mr: 0.3 }}
                    sizebutton="m"
                    onClick={() => handleClick(null)}
                >
                    {t("navBar.convert")}
                </BaseButton>
                <BaseButton
                    size="small"
                    aria-controls={openBtnGroupSend ? "split-button-menu" : undefined}
                    aria-expanded={openBtnGroupSend ? "true" : undefined}
                    aria-label="select merge strategy"
                    aria-haspopup="menu"
                    disableElevation
                    variant="contained"
                    color={todos.companyID ? "primary" : "secondary"}
                    onClick={handleToggleBtnGroup}
                >
                    <ArrowDropDownIcon />
                </BaseButton>
            </ButtonGroup>
            <Popper
                sx={{
                    zIndex: 1,
                    pt: 1,
                }}
                open={openBtnGroupSend}
                anchorEl={anchorRefBtnGroup.current}
                role={undefined}
                transition
                disablePortal
                style={{ width: 270 }}
                modifiers={[
                    {
                        name: "offset",
                        options: {
                            offset: [-46, 0], // Ajuste de desplazamiento vertical
                        },
                    },
                ]}
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: placement === "bottom" ? "center top" : "center bottom",
                        }}
                    >
                        <Paper
                            sx={{
                                borderRadius: "20px",
                                boxShadow: "4px 4px 15px rgba(74, 34, 212, 0.15)",
                            }}
                        >
                            <ClickAwayListener onClickAway={handleCloseBtnGroup}>
                                <MenuList id="split-button-menu" autoFocusItem>
                                    {optionsGroupSend.map(({ id, data }, index) => (
                                        <MenuItem
                                            key={"convertOption_" + id}
                                            selected={index === selectedIndexBtnGroup}
                                            onClick={(event) => handleMenuItemClickBtnGroup(event, index)}
                                            sx={{
                                                fontSize: { md: 12, lg: 13 },
                                            }}
                                        >
                                            {data}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </>
    );
};

export default ConvertButton;
